<template>
  <div class="whitebox accordion">
    <div class="accordion-header" @click="toggleOpen">
      <div class="accordion-icon">
        <font-awesome-icon v-if="props.icon" :icon="['fas', props.icon]" />
      </div>
      <div class="accordion-header-content">
        <slot name="header" />
        <div class="subtitle">
          <Transition name="header">
            <slot v-if="!isOpen" name="subtitle" class="subtitle" />
          </Transition>
        </div>
      </div>
      <div class="accordion-chevron">
        <Transition name="chevron" mode="out-in">
          <font-awesome-icon v-if="isOpen" :icon="['fas', 'chevron-up']" />
          <font-awesome-icon v-else :icon="['fas', 'chevron-down']" />
        </Transition>
      </div>
    </div>
    <TransitionGroup name="accordion">
      <template v-if="isOpen">
        <div
          class="accordion-content"
          :class="{ 'content-full-width': isContentFullWidth }"
        >
          <slot name="content" />
        </div>
        <div class="accordion-footer">
          <slot name="footer" />
        </div>
      </template>
    </TransitionGroup>
  </div>
</template>

<script setup>
const isOpen = ref(props.open);
const props = defineProps({
  icon: {
    type: String,
    required: false,
  },
  open: {
    type: Boolean,
    default: false,
  },
  isContentFullWidth: {
    type: Boolean,
    default: false,
  },
});
const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped lang="scss">
.accordion {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
}

.accordion-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  gap: 8px;
  cursor: pointer;
}

.accordion-header-content {
  flex: 1;
}

.accordion-content {
  margin-left: 44px;
  margin-right: 32px;
  padding: 0px 12px;
}

.content-full-width.accordion-content {
  margin: 0;
  padding-top: 12px;
  border-top: 1px solid var(--gray200);
}

.accordion-footer {
  margin-left: 44px;
  margin-right: 32px;
  padding: 4px 12px 12px 12px;
}

.accordion-icon {
  padding: 6px;
  border-radius: 8px;
  background: var(--gray50);
  align-self: start;
  svg {
    display: block;
    color: var(--brandPrimary);
    width: 24px;
    height: 24px;
  }
}

.accordion-chevron {
  font-size: 18px;
}
</style>

<style lang="scss">
// Transition style

.accordion-enter-active,
.accordion-leave-active {
  transition: 0.1s linear;
  -webkit-transition: 0.1s linear;
  -moz-transition: 0.1s linear;
}

.accordion-enter-to,
.accordion-leave-from {
  max-height: 100px;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  overflow: hidden;
  max-height: 0px;
}

.header-enter-active,
.header-leave-active {
  transition: 0.1s linear;
  -webkit-transition: 0.1s linear;
  -moz-transition: 0.1s linear;
}

.header-enter-to,
.header-leave-from {
  max-height: 12px;
  overflow: hidden;
}

.header-enter-from,
.header-leave-to {
  max-height: 0px;
  overflow: hidden;
}

.chevron-enter-active,
.chevron-leave-active {
  transition: 0.1s linear;
  -webkit-transition: 0.1s linear;
  -moz-transition: 0.1s linear;
}

.chevron-leave-from {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
}

.chevron-leave-to {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
}

@media only screen and (max-width: 792px) {
  .subtitle {
    display: none;
  }
}
</style>
